import {map, kebabCase, camelCase} from 'lodash';

function reconstructName(prefix, variant, suffix) {
    if (!variant) return null;
    const nameParts = [prefix, variant];
    if (suffix) nameParts.push(suffix);
    return kebabCase(nameParts.join('-'));
}

function getNewValue(propName, changes) {
    if (!changes[propName]) return null;
    const {currentValue, previousValue} = changes[propName];
    return currentValue !== previousValue && currentValue;
}

class DynamicComponent {
    constructor($scope, $element, $attrs, $compile, $injector) {

        const checkAttrs = () => {
            if ($attrs.name && ($attrs.prefix || $attrs.variant)) {
                throw new Error('In DynamicComponent you can not use name and prefix+variant simultaneously');
            }
            if (!$attrs.name && !($attrs.variant && $attrs.prefix)) {
                throw new Error('DynamicComponent expect either name or prefix+variant with optional suffix');
            }
        };

        const componentType = $attrs.name ? 'name' : 'variant';

        const replaceComponent = name => {
            if (name) {
                const argString = map(this.props, (v, k) => `${kebabCase(k)}="${v}"`).join(' ');
                const compHtml = `<${kebabCase(name)} ${argString}></${name}>`;
                const component = $compile(compHtml)($scope.$parent)[0];
                $element.replaceWith(component);
            }
        };

        const getName = name => name || this.defaultName;

        const getNameFromVariant = variant => {
            const _variant = variant || this.defaultVariant;
            if (!_variant) return null;
            const name = reconstructName(
                this.prefix,
                _variant,
                this.suffix
            );

            if ($injector.has(camelCase([name, 'directive'].join('-')))) {
                return name;
            }
            return reconstructName(this.prefix, this.defaultVariant, this.suffix);
        };

        this.$onInit = () => {
            checkAttrs();
            if (componentType === 'name') {
                return replaceComponent(getName(this.name));
            }
            if (componentType === 'variant') {
                return replaceComponent(getNameFromVariant(this.variant));
            }
        };

        this.$onChanges = changes => {
            if (componentType === 'name' && changes.name) {
                const newName = getNewValue('name', changes);
                return replaceComponent(getName(newName), this.props);
            }
            if (componentType === 'variant' && changes.variant) {
                const newVariant = getNewValue('variant', changes);
                replaceComponent(getNameFromVariant(newVariant), this.props);
            }
            if (changes.props) {
                const name = componentType === 'name' ? getName(this.name) : getNameFromVariant(this.variant);
                const newProps = getNewValue('props', changes);
                if (newProps) replaceComponent(name, newProps);
            }
        };
    }
}

DynamicComponent.$inject = ['$scope', '$element', '$attrs', '$compile', '$injector'];

export default DynamicComponent;
